<template>
  <el-form 
    ref="form" 
    :model="formData" 
    :rules="rules"
    label-width="100px">
    <el-form-item label="商品名称" prop="name">
      <el-input v-model="formData.name" placeholder="请输入商品名称"></el-input>
    </el-form-item>
    
    <el-form-item label="商品编码" prop="code">
      <el-input v-model="formData.code" placeholder="请输入商品编码"></el-input>
    </el-form-item>
    
    <el-form-item label="商品分类" prop="category">
      <el-select v-model="formData.category" placeholder="请选择商品分类">
        <el-option
          v-for="item in categories"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    
    <el-form-item label="预警阈值" prop="threshold">
      <el-input-number 
        v-model="formData.threshold" 
        :min="0"
        :precision="0"
        :step="1">
      </el-input-number>
    </el-form-item>
    
    <el-form-item label="备注" prop="remark">
      <el-input 
        type="textarea"
        v-model="formData.remark"
        placeholder="请输入备注信息">
      </el-input>
    </el-form-item>
    
    <el-form-item>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
      <el-button @click="$emit('cancel')">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'ProductForm',
  props: {
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        name: '',
        code: '',
        category: '',
        threshold: 10,
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入商品编码', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ]
      },
      categories: [
        { value: 'electronics', label: '电子产品' },
        { value: 'clothing', label: '服装' },
        { value: 'food', label: '食品' }
      ]
    }
  },
  created() {
    Object.assign(this.formData, this.initialData)
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('submit', this.formData)
        }
      })
    }
  }
}
</script> 